<style lang="sass">
    @import ../../common/styles/mixins
    @import ../../common/styles/settings
    @import landing-boat

</style>

<script>

    export default {

        props: {
            dataProps: {
                type: String,
                required: true
            }
        },

        data() {
            return {
                formCompleted: false,
                recaptcha: {
                    key: '6LenR2oUAAAAAGFoCwZ5pDTO-q1J-7WMR_AtJEV2',    // Dev
                    // key: '??'  // Prod
                },
                form: {
                    lastname: '',
                    firstname: '',
                    email: '',
                    captcha: '',
                    promofinagaz: '',
                    promopartners: '',
                    acceptance: ''
                },
                formEl: null
            }
        },

        computed: {
            displayPicture () {
              //return !this.props.hasParticipated && this.props.isRightAnswer;
              return this.props.isRightAnswer;
            },
            displayDefaultContent () {
                return this.props.hasParticipated || (!this.props.hasParticipated && !this.props.isRightAnswer)
            },
            displayEnding () {
                return this.formCompleted
            },
            displayForm () {
                return !this.props.hasParticipated && this.props.isRightAnswer && !this.formCompleted
            },
            props () {
                return JSON.parse(this.dataProps)
            }
        },
        /*
        created () {
            this.formCompleted = this.dataFormCompleted
            this.form.email = this.props.email
        },
        */
        mounted () {
            this.formEl = this.$el.querySelector('form')
            this.formCompleted = this.formEl.querySelector('.webform-confirmation') !== null

        },
        methods: {

            sendForm () {
                for (let [key, value] of Object.entries(this.form)) {
                    let input = this.formEl.querySelector(`[name='${key.toLowerCase()}']`)
                    if (input) {
                        switch(key) {
                            case 'promofinagaz':
                                input.value = value ? this.props.optPromo : ''
                                break;
                            case 'promopartners':
                                input.value = value ? this.props.optPartners : ''
                                break;
                            case 'acceptance':
                                input.value = "Participer"
                                break;
                            default:
                                input.value = value
                                break;
                        }
                    }
                }
            },

            submit() {
                this.form.captcha = window.grecaptcha.getResponse()
                
                this.$validator.validateAll().then(result => {

                    if (result && this.form.captcha.length > 0) {
                        this.sendForm()
                        this.formEl.submit()
                        this.formCompleted = true
                    }
                })
            }
        }
    }
</script>
